
import Vue from 'vue';
export default {
    scrollToTop: true,
    head() {
        return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full details of Ashtavinayak "Shree Girijatmaj Ganpati Temple Lenyadri" in English.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full details of Ashtavinayak "Shree Girijatmaj Ganpati Temple Lenyadri" in English.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shree Girijatmaj Temple, Girijatmaj Ganpati Lenyadri, Ashtavinayak Ganpati Lenyadri, Lenyadri Ganpati Temple, Girijatmaj Vinayak Cave Temple, Ashtavinayak Yatra Lenyadri, Ganpati Temple Lenyadri Maharashtra'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shree Girijatmaj Temple, Girijatmaj Ganpati Lenyadri, Ashtavinayak Ganpati Lenyadri, Lenyadri Ganpati Temple, Girijatmaj Vinayak Cave Temple, Ashtavinayak Yatra Lenyadri, Ganpati Temple Lenyadri Maharashtra, Girijatmaj Ganesh Temple Pune, Lenyadri Caves Ganpati, lenyadri ganpati temple, lenyadri ganpati steps, lenyadri ganpati distance, lenyadri ganpati temple timings, lenyadri ganpati location' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/ashtavinayak/girijatmaj.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/ashtavinayak/girijatmaj.webp'
          },
        ],
    }
},

    components: {
    },
    data() {
        return {
            title: 'Shree Girijatmaj Ganpati Temple Lenyadri | Ashtavinayak - श्री गिरिजात्मजा गणेशा लेण्यांद्री(अष्टविनायक)',
            langauageMarathi: true
        }
    },
    layout: 'detailsPage-withoutFooter',

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/ashtavinayak/girijatmaj"
        },
        "headline": "Shree Girijatmaj Ganpati Temple Lenyadri - श्री गिरिजात्मजा गणेशा लेण्यांद्री(अष्टविनायक)",
        "name" : "Shree Girijatmaj Ganpati Temple Lenyadri - Ashtavinayak",
        "description": "Explore the full details of Ashtavinayak 'Shree Girijatmaj Ganpati Temple Lenyadri' in English.",
        "image": this.$config.siteUrl + '/img/ashtavinayak/girijatmaj.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

    computed: {

    },
    methods: {
        changeLanguage: function () {
            this.langauageMarathi = !this.langauageMarathi
        }
    }

}
